module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"refresh_confirmation":"Are you sure you want to leave?"}}')
  delete Component.options._Ctor
}
